// extracted by mini-css-extract-plugin
export default {"badge":"badge-module__badge--rJ3","green":"badge-module__green--y8E","gray":"badge-module__gray--pSb"};